// ** Initial State
const STORAGE_KEY = "emailTemplateTable.pagination";

function loadPersistedPagination() {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    return parsed;
  } catch (err) {
    return null;
  }
}

const persisted = loadPersistedPagination();

// default pagination + default empty filter/sort
const defaultPagination = {
  limit: 30,
  page: 0,
  total_pages: null,
  total_records: null,
  data: null,
  filter: { code: "", name: "", subject: "" },
  sort: { field: "code", order: "asc" },
};

const initialState = {
  allData: [],
  data: null,
  emailDataWithPagintion: persisted
    ? Object.assign({}, defaultPagination, {
        // only take pagination and sort from persisted; ignore any persisted.filter
        limit:
          typeof persisted.limit !== "undefined"
            ? persisted.limit
            : defaultPagination.limit,
        page:
          typeof persisted.page !== "undefined"
            ? persisted.page
            : defaultPagination.page,
        total_pages:
          typeof persisted.total_pages !== "undefined"
            ? persisted.total_pages
            : defaultPagination.total_pages,
        total_records:
          typeof persisted.total_records !== "undefined"
            ? persisted.total_records
            : defaultPagination.total_records,
        data:
          typeof persisted.data !== "undefined"
            ? persisted.data
            : defaultPagination.data,
        sort: persisted.sort ? persisted.sort : defaultPagination.sort,
        filter: defaultPagination.filter,
      })
    : Object.assign({}, defaultPagination),
  pageLoader: true,
};

const emailtemplate = (state = initialState, action) => {
  switch (action.type) {
    case "GET_ALL_TEMPLATE":
      return Object.assign({}, state, { allData: action.data });
    case "GET_DATA":
      return Object.assign({}, state, { data: action.data });
    case "SET_DATA":
      return Object.assign({}, state, { data: null });
    case "GET_ALL_EMAILTEMPLETE_WITH_PAGINATION":
      try {
        // persist pagination to localStorage for cross-refresh consistency
        // DO NOT persist filter (search) — only save page, limit and sort
        localStorage.setItem(
          STORAGE_KEY,
          JSON.stringify({
            page: action.data.page,
            limit: action.data.limit,
            sort: action.data.sort,
          })
        );
      } catch (err) {
        // ignore storage errors
      }
      return Object.assign({}, state, {
        emailDataWithPagintion: action.data,
        pageLoader: false,
      });
    case "PAGE_LOADER":
      return Object.assign({}, state, { pageLoader: action.data });
    case "EMPTY_EMAIL_TEMPLATE":
      return Object.assign({}, state, { data: null });
    default:
      return Object.assign({}, state);
  }
};
export default emailtemplate;
